export enum LogoVariant {
    solid = 'solid',
    outline = 'outline',
}

export default null; // added default export to prevent a compile time error
